export default __webpack_public_path__ + "static/media/first-slide-medium.114c1cff.jpg";